import { SafetyPointModelView } from "./safety-point-model";

export class RoofareaModel {
    public RoofareaID: number = 0;
    public ObjektID: number = 0;
    public Bezeichnung: string = "";
    public Longitude: number | null = null;
    public Latitude: number | null = null;
}

export interface RoofareaModelView {
    RoofareaID?: number;
    StandortID?: number;
    DebitorID?: number;
    ObjektID?:number;
    ObjektBezeichnung?: string;
    
    Strasse?: string | null;
    PLZ?: string | null;
    Ort?: string | null;
    LandID?: number | null;
    
    LandName?: string | null;
    Debitornummer?: number|null;
    Debitorname?: string|null;
    StandortBezeichnung? :string|null;
    Bezeichnung?: string 

} 

export class RoofAreaView {
  public panelOpen: boolean = false;

  constructor(
    public roofArea: RoofareaModel,
    public safetyPointList: SafetyPointModelView[]
  ) { }
}